const BASE_API_URL = process.env.NEXT_PUBLIC_API_URL;
export const API_URL = Object.freeze({
    USER: `${BASE_API_URL}/user`,
    USER_INSTAGRAM: `${BASE_API_URL}/user/change-instagram`,
    USER_NAME: `${BASE_API_URL}/user/change-name`,
    USER_SOL: `${BASE_API_URL}/user/change-sol`,
    CHANGE_PASSWORD: `${BASE_API_URL}/user/change-password`,
    REGISTER: `${BASE_API_URL}/user/register`,
    LOGIN: `${BASE_API_URL}/user/login`,
    CONFIRMATION_NUMBER: `${BASE_API_URL}/user/verifyEmail`,
    CONFIRMATION_NUMBER_RESEND: `${BASE_API_URL}/user/resendVerifyEmail`,
    CREATE_PROMOTER: `${BASE_API_URL}/user/create-promoter`,
    PAYMENT: `${BASE_API_URL}/payment`,
    DISCORD_AUTH: `${BASE_API_URL}/discord/auth`,
    DISCORD_LOGOUT: `${BASE_API_URL}/discord/disconnect`,
    DISCORD_ROLE: `${BASE_API_URL}/discord/role`,
    FIRST_PROMOTER: `${BASE_API_URL}/first-promoter`,
    VIDEO_LIST: `${BASE_API_URL}/video/videos`,
    VIDEO_CATEGORIES: `${BASE_API_URL}/video/categories`,
    VIDEO_UPDATE: `${BASE_API_URL}/video/metadata`,
    FORGOT_PASSWORD: `${BASE_API_URL}/user/forgot-password`,
    VERIFY_RESET_PASSWORD: `${BASE_API_URL}/user/verify-reset-password`,
    RESET_PASSWORD: `${BASE_API_URL}/user/reset-password`,
    REQUEST_CHANGE_EMAIL: `${BASE_API_URL}/user/request-change-email`,
    VERIFY_CHANGE_EMAIL: `${BASE_API_URL}/user/verify-change-email`,
    CHANGE_EMAIL: `${BASE_API_URL}/user/change-email`,

})
